import { Navigate, useParams } from 'react-router-dom';

import { LoaderComponent } from '@/shared/components/ui';
import { SaveEmpleados } from '../../shared/components/saveEmpledos';
import { useGetEmpleado } from '@/shared/actions/erp/empleados';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export interface UpdateEmpleadoPageInterface {}

const UpdateEmpleadoPage: React.FC<UpdateEmpleadoPageInterface> = () => {

  useCheckPermissions(PermissionsEnum.api_change_empleado)

  const { id } = useParams();
  const { data, isLoading } = useGetEmpleado(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_empleado) return <Navigate to="/nomina/empleados" />;

 
  return (
    <SaveEmpleados titlePage="Editar Empleados" editEmpleados={data.data} />
  );
};

export default UpdateEmpleadoPage;
